/**
 *    Bauhaus100 (Body)
 *
 *    @tableofcontent
 *      1. Default dependencies
 *       1.1 jQuery
 *      2. Components
 *       2.1 Header
 *       2.2 Image collection
 *       2.3 Image swap
 *       2.4 Image with text overlay
 *       2.5 Highlight
 *       2.6 Quote
 *       2.7 Button to top
 *       2.8 Dropdown
 *       2.9 Tabs
 *       2.10 Datepicker
 *       2.11 Cookie hint
 *       2.12 Modal
 *       2.13 Event
 *       2.14 Map
 *       2.15 Hint
 *       2.16 Achievement
 *       2.17 Popup
 *       2.18 Filter
 *       2.19 Popover
 *      3. Form
 *       3.1 Form defaults
 *       3.2 Geo location
 *       3.3 Program
 *      4. Utils
 *       4.1 Tooltip
 *       4.2 Sticky
 *       4.3 Video
 *       4.4 Auto complete
 *       4.5 Carousel
 *       4.6 Viewport
 *       4.7 Smooth anchor scroll
 *       4.8 Breakpoints
 *       4.9 Image
 *       4.10 Responsive images
 *       4.11 Options (website)
 *       4.12 Drag scroll
 *       4.13 Masonry
 *       4.14 Image zoom
 *      5. Polyfills
 *       5.1 XmBauDb - biography filters
 *       5.2 XmBauDb - publication filters
 *       5.3 XmBau100 - magazine article list
 *       5.4 XmBau100 - magazine weekly teaser
 *
 */

// use strict mode
(function () {
    'use strict';
}());


/**
 *     @section 1. Dependencies
 */

//  @section 1.1 jQuery
import $ from 'jquery';
window.jQuery = $;
window.$ = $;


/**
 *     @section 2. Components
 */

// @section 2.1 Header
if(document.querySelectorAll('[data-load-script="header"]').length) {
    import('./component/_header')
        .then((module) => {
            module.default.init()
        })
        .catch(() => {
            console.warn('Header could not be loaded')
        })
}

// @section 2.2 Image collection
if(document.querySelectorAll('[data-load-script="imageCollection"]').length) {
    import('./component/_image-collection')
        .then((module) => {
            module.default.init()
        })
        .catch(() => {
            console.warn('Image collection could not be loaded')
        })
}

// @section 2.3 Image swap
if(document.querySelectorAll('[data-load-script="imageSwap"]').length) {
    import('./component/_image-swap')
        .then((module) => {
            module.default.init()
        })
        .catch(() => {
            console.warn('Image swap could not be loaded')
        })
}

// @section 2.4 Image with text overlay
if(document.querySelectorAll('[data-load-script="imageWithTextOverlay"]').length) {
    import('./component/_image-with-text-overlay')
        .then((module) => {
            module.default.init()
        })
        .catch(() => {
            console.warn('Image with text overlay could not be loaded')
        })
}

// @section 2.5 Highlight
if(document.querySelectorAll('[data-load-script="highlight"]').length) {
    import('./component/_highlight')
        .then((module) => {
            module.default.init()
        })
        .catch(() => {
            console.warn('Highlight could not be loaded')
        })
}

// @section 2.6 Quote
if(document.querySelectorAll('[data-load-script="quote"]').length) {
    import('./component/_quote')
        .then((module) => {
            module.default.init()
        })
        .catch(() => {
            console.warn('Quote could not be loaded')
        })
}

// @section 2.7 Button to top
if(document.querySelectorAll('[data-load-script="buttonToTop"]').length) {
    import('./component/_button-to-top')
        .then((module) => {
            module.default.init()
        })
        .catch(() => {
            console.warn('Button to top could not be loaded')
        })
}

// @section 2.8 Dropdown
if(document.querySelectorAll('[data-load-script="dropdown"]').length) {
    import('./component/_dropdown')
        .then((module) => {
            module.default.init()
        })
        .catch(() => {
            console.warn('Dropdown could not be loaded')
        })
}

// @section 2.9 Tabs
if(document.querySelectorAll('[data-load-script="tabs"]').length) {
    import('./component/_tabs')
        .then((module) => {
            module.default.init()
        })
        .catch(() => {
            console.warn('Tabs could not be loaded')
        })
}

// @section 2.10 Datepicker
if(document.querySelectorAll('[data-load-script="datepicker"]').length) {
    import('./component/_datepicker')
        .then((module) => {
            module.default.init()
        })
        .catch(() => {
            console.warn('Datepicker could not be loaded')
        })
}

// @section 2.11 Cookie hint
if(document.querySelectorAll('[data-module="cookie__dialog"]').length) {
    import('./component/_cookie-hint')
        .catch(() => {
            console.warn('Cookie hint could not be loaded')
        })
}

// @section 2.12 Modal
if(document.querySelectorAll('[data-load-script="modal"]').length) {
    import('./component/_modal')
        .then((module) => {
            module.default.init()
        })
        .catch(() => {
            console.warn('Modal could not be loaded')
        })
}

// @section 2.13 Event
if(document.querySelectorAll('[data-load-script="event"]').length) {
    import('./component/_event')
        .then((module) => {
            module.default.init()
        })
        .catch(() => {
            console.warn('Event could not be loaded')
        })
}

// @section 2.14 Map
if(document.querySelectorAll('[data-load-script="map"]').length) {
    import('./component/_map')
        .then((module) => {
            module.default.init()
        })
        .catch(() => {
            console.warn('Map could not be loaded')
        })
}

// @section 2.15 Hint
if(document.querySelectorAll('[data-load-script="hint"]').length) {
    import('./component/_hint')
        .then((module) => {
            module.default.init()
        })
        .catch(() => {
            console.warn('Hint could not be loaded')
        })
}

// @section 2.16 Achievement
import('./component/_achievement')
    .then((module) => {
        module.default.init()
    })
    .catch(() => {
        console.warn('Achievement could not be loaded')
    })

// @section 2.17 Popup
if(document.querySelectorAll('[data-load-script="popup"]').length) {
    import('./component/_popup')
        .then((module) => {
            module.default.init()
        })
        .catch(() => {
            console.warn('Popup could not be loaded')
        })
}

// @section 2.18 Filter
if(document.querySelectorAll('[data-load-script="filter"]').length) {
    import('./component/_filter')
        .then((module) => {
            module.default.init()
        })
        .catch(() => {
            console.warn('Filter could not be loaded')
        })
}

// @section 2.19 Popover
if(document.querySelectorAll('[data-toggle="popover"]').length) {
    import('./component/_popover')
        .then((module) => {
            module.default.init()
        })
        .catch(() => {
            console.warn('Popover could not be loaded')
        })
}


/**
 *     @section 3. Form
 */

// @section 3.1 Form defaults
if(document.querySelectorAll('[data-load-script="form"]').length) {
    import('./form/_form')
        .then((module) => {
            module.default.init()
        })
        .catch(() => {
            console.warn('Form could not be loaded')
        })
}

// @section 3.2 Geo location
if(document.querySelectorAll('[data-load-script="geoLocation"]').length) {
    import('./form/_geo-location')
        .then((module) => {
            module.default.init()
        })
        .catch(() => {
            console.warn('Geo location could not be loaded')
        })
}

// @section 3.3 Program
if(document.querySelectorAll('[data-load-script="program"]').length) {
    import('./form/_program')
        .then((module) => {
            module.default.init()
        })
        .catch(() => {
            console.warn('Program could not be loaded')
        })
}

// @section 3.4 Solr Knowledge
if(document.querySelectorAll('[data-load-script="solrKnowledge"]').length) {
    import('./form/_solr-knowledge')
        .then((module) => {
            module.default.init()
        })
        .catch(() => {
            console.warn('Solr knowledge could not be loaded')
        })
}


/**
 *     @section 4. Utils
 */

// @section 4.1 Tooltip
if(document.querySelectorAll('[data-load-script="tooltip"]').length) {
    import('./util/_tooltip')
        .then((module) => {
            module.default.init()
        })
        .catch(() => {
            console.warn('Tooltip could not be loaded')
        })
}

// @section 4.2 Sticky
if(document.querySelectorAll('[data-load-script="sticky"]').length) {
    import('./util/_sticky')
        .then((module) => {
            module.default.init()
        })
        .catch(() => {
            console.warn('Sticky could not be loaded')
        })
}

// @section 4.3 Video
if(document.querySelectorAll('[data-load-script="customScroll"]').length) {
    import('./util/_custom-scroll')
        .then((module) => {
            module.default.init()
        })
        .catch(() => {
            console.warn('Custom scroll could not be loaded')
        })
}

// @section 4.4 Auto complete
// nothing yet

// @section 4.5 Carousel
if(document.querySelectorAll('[data-load-script="carousel"]').length) {
    import('./component/_carousel')
        .then((module) => {
            module.default.init()
        })
        .catch(() => {
            console.warn('Carousel could not be loaded')
        })
}

// @section 4.6 Viewport
if(document.querySelectorAll('[data-load-script="viewport"]').length) {
    import('./util/_viewport')
        .then((module) => {
            module.default.init()
        })
        .catch(() => {
            console.warn('Viewport could not be loaded')
        })
}

// @section 4.7 Smooth anchor scroll
if(document.querySelectorAll('[data-load-script="smoothAnchorScroll"]').length) {
    import('./util/_smooth-anchor-scroll')
        .then((module) => {
            module.default.init()
        })
        .catch(() => {
            console.warn('Smooth anchor scroll could not be loaded')
        })
}

// @section 4.8 Breakpoints
if(document.querySelectorAll('[data-load-script="breakpoints"]').length) {
    import('./util/_breakpoints')
        .then((module) => {
            module.default.init()
        })
        .catch(() => {
            console.warn('Breakpoints could not be loaded')
        })
}

// @section 4.9 Image
if(document.querySelectorAll('[data-load-script="image"]').length) {
    import('./util/_image')
        .then((module) => {
            module.default.init()
        })
        .catch(() => {
            console.warn('Image could not be loaded')
        })

    import('./util/_copyright')
        .then((module) => {
            module.default.init()
        })
        .catch(() => {
            console.warn('Copyright could not be loaded')
        })
}

// @section 4.10 Responsive images
// if(document.querySelectorAll('[data-load-script="responsiveImages"]').length) {
//     import('./util/_responsive-images')
//         .then((module) => {
//             module.default.init()
//         })
//         .catch(() => {
//             console.warn('Responsive images could not be loaded')
//         })
// }

// @section 4.11 Options (website)
if(document.querySelectorAll('[data-load-script="options"]').length) {
    import('./util/_options')
        .then((module) => {
            module.default.init()
        })
        .catch(() => {
            console.warn('Options could not be loaded')
        })
}

// @section 4.12 Drag scroll
if(document.querySelectorAll('.dragscroll').length) {
    import('./util/_drag-scroll')
        .then((module) => {
            module.default.init()
        })
        .catch(() => {
            console.warn('Drag scroll could not be loaded')
        })
}

// @section 4.13 Masonry
if(document.querySelectorAll('[data-load-script="masonry"]').length) {
    import('./util/_masonry')
        .then((module) => {
            module.default.init()
        })
        .catch(() => {
            console.warn('Masonry could not be loaded')
        })
}

// @section 4.14 Image zoom
if(document.querySelectorAll('[data-load-script="zoom"]').length) {
    import('./util/_image-zoom')
        .then((module) => {
            module.default.init()
        })
        .catch(() => {
            console.warn('Image zoom could not be loaded')
        })
}


/**
 *     @section 5. Polyfills
 */

// @section 5.1 XmBauDb - biography filters
if(document.querySelectorAll('[data-load-script="XmBauDbBiographyFilter"]').length) {
    import('../typo3-ext/xm_bau_db/Resources/Public/JavaScript/XmBauDbBiographyFilter')
        .then((module) => {
            module.default.init()
        })
        .catch(() => {
            console.warn('XmBauDbBiographyFilter could not be loaded')
        })
}

// @section 5.2 XmBauDb - publication filters
if(document.querySelectorAll('[data-load-script="XmBauDbPublicationFilter"]').length) {
    import('../typo3-ext/xm_bau_db/Resources/Public/JavaScript/XmBauDbPublicationFilter')
        .then((module) => {
            module.default.init()
        })
        .catch(() => {
            console.warn('XmBauDbPublicationFilter could not be loaded')
        })
}

// @section 5.3 XmBau100 - magazine article list
if(document.querySelectorAll('[data-load-script="XmBau100MagazineArticleList"]').length) {
    import('../typo3-ext/xm_bau100_magazine/Resources/Public/JavaScript/XmBau100MagazineArticleList')
        .then((module) => {
            module.default.init()
        })
        .catch(() => {
            console.warn('XmBau100MagazineArticleList could not be loaded')
        })
}

// @section 5.4 XmBau100 - magazine weekly teaser
if(document.querySelectorAll('[data-load-script="XmBau100MagazineWeeklyTeaser"]').length) {
    import('../typo3-ext/xm_bau100_magazine/Resources/Public/JavaScript/XmBau100MagazineWeeklyTeaser')
        .then((module) => {
            module.default.init()
        })
        .catch(() => {
            console.warn('XmBau100MagazineWeeklyTeaser could not be loaded')
        })
}

// end of bau100--body.js
